import type { ISocialApply } from "@bbj-types/socialApply";
import type { ObjectId } from "@bbj-types/utils/index";
import { useCallback } from "react";
import { axios } from "./axios";

export interface IGetSocialAppliesRes {
  limit: number;
  skip: number;
  total: number;
  count: number;
  data: ISocialApply[];
}
export const useGetSocialApplies = () => {
  const [state, execute, cancel] = axios<IGetSocialAppliesRes, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidate: ObjectId, skip: number, limit: number) => {
      return execute({
        url: `/applys/social/candidate/${candidate}`,
        params: {
          skip,
          limit,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
